export const MODEL_COLORS = {
  "gpt-6.1-sol": "bg-brand-gpt",
  "gemini-3-pro-preview": "bg-brand-gemini",
  "claude-opus-5.5": "bg-brand-claude",
};

export const MODEL_NAMES = {
  "gpt-6.1-sol": { en: "AI-1", ru: "ИИ-1" },
  "claude-opus-5.5": { en: "AI-2", ru: "ИИ-2" },
  "gemini-3-pro-preview": { en: "AI-3", ru: "ИИ-3" },
};

// Backing-model choices for persona configuration. Short technical names —
// these label the underlying LLM, NOT the specialist identity.
export const BACKING_MODELS = [
  { id: "gpt-6.1-sol", name: "GPT-6.1 Sol" },
  { id: "claude-opus-5.5", name: "Claude Opus 5.5" },
  { id: "gemini-3-pro-preview", name: "Gemini 3 Pro" },
];

export const BACKING_MODEL_NAMES = BACKING_MODELS.reduce((acc, m) => {
  acc[m.id] = m.name;
  return acc;
}, {});
